import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityIssyLesMoulineauxPage() {
  const data = citiesData.find((c) => c.slug === "issy-les-moulineaux")!;
  return <CityPage data={data} />;
}
